import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询
export function queryFunc(data) {
  return request({
    url: URL.sys.automationConfig.queryUrl,
    method: 'post',
    data
  })
}

// 检查任务名称是否重复
export function checkTaskNameFunc(data) {
  return request({
    url: URL.sys.automationConfig.checkTaskNameUrl,
    method: 'post',
    data
  })
}

// 保存配置
export function saveConfigFunc(data) {
  return request({
    url: URL.sys.automationConfig.saveConfigUrl,
    method: 'post',
    data
  })
}

// 删除配置
export function deleteAutoConfigFunc(data) {
  return request({
    url: URL.sys.automationConfig.deleteAutoConfigUrl,
    method: 'post',
    data
  })
}

// 复制配置
export function copyConfigFunc(data) {
  return request({
    url: URL.sys.automationConfig.copyConfigUrl,
    method: 'post',
    data
  })
}

// 任务详情
export function taskDetailFunc(data) {
  return request({
    url: URL.sys.automationConfig.taskDetailUrl,
    method: 'post',
    data
  })
}

// 指令详情
export function commandDetailFunc(data) {
  return request({
    url: URL.sys.automationConfig.commandDetailUrl,
    method: 'post',
    data
  })
}

// 执行历史
export function taskLogFunc(data) {
  return request({
    url: URL.sys.automationConfig.taskLogUrl,
    method: 'post',
    data
  })
}

// 手动运行
export function manualRunFunc(data) {
  return request({
    url: URL.act.invoice.manualRunUrl,
    method: 'post',
    data
  })
}
// 手动运行
export function pushShippingExchangeFunc(data) {
  return request({
    url: URL.act.invoice.pushShippingExchangeUrl,
    method: 'post',
    data
  })
}
// 手动运行
export function executeAutomationPushMls(data) {
  return request({
    url: URL.act.invoice.executeAutomationPushMlsTaskUrl,
    method: 'post',
    data
  })
}
// 手动运行
export function executePushThirdPartyDataTask(data) {
  return request({
    url: URL.sys.automationTask.executePushThirdPartyDataTaskUrl,
    method: 'post',
    data
  })
}
